// @flow

import React, { Fragment } from "react";

import Common from "./Common";
import * as notifications from "src/constants/notifications";
import type { Message } from "src/types";
import GroupMembersModal from "./GroupMembersModal";

type Props = {
  message: Message,
};

const Group = ({ message }: Props) => {
  const { data: groupIds, action } = message;
  const groupAddAction = action === notifications.GROUP_ADD;
  const userAction = groupAddAction ? "added" : "removed";

  return (
    <Common {...message}>
      {" "}
      {userAction}{" "}
      {groupIds.map((group, i) => {
        const { id } = group;

        return (
          <Fragment key={id}>
            {i === groupIds.length - 1 && groupIds.length > 1 && " and "}
            <strong>
              <GroupMembersModal id={id} />
            </strong>
            {i !== groupIds.length - 2 &&
              i !== groupIds.length - 1 &&
              groupIds.length > 1 &&
              ", "}
          </Fragment>
        );
      })}
    </Common>
  );
};

export default Group;
